//import {AppConfig} from "../config"

/*** PARA DEPRECAR ***/


import Schema from "./schema"

export const METHOD_PUT = 'PUT'
export const METHOD_POST = 'POST'
export const METHOD_DELETE = 'DELETE'
export const METHOD_GET = 'GET'


const  queryParams = (params) => {
    return Object.keys(params)
        .map(k => {
            const valor = params[k]
            const campo = encodeURIComponent(k)

            if (Array.isArray(valor)) {
                return valor.map((v)=>campo + '[]=' + encodeURIComponent(v)).join('&')
            }

            return campo + '=' + encodeURIComponent(params[k])
        })
        .join('&')
}

const createRequest = async (method, url, token, params = {}, schema ) => {

    // let reqUrl = AppConfig.api.baseUrl + url
    let reqUrl = url;

    const fetchParams = {
        method: method,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'schema': schema ,
        },
        mode: 'cors',
        body: JSON.stringify(params)
    }


    if (!!token) {
        fetchParams.headers['Authorization'] = `Bearer ${token}`
    }




    if (method === METHOD_GET) {


        if (!token) {
            const instance = await Schema.get()
            const schema = instance.schema


            if (reqUrl.indexOf('?') >= 0 )
                 reqUrl+='&'
            else
                reqUrl+='?'


            reqUrl+=`username=${schema}.site&token=NTkzNjE2ZGUxNTMzMGMwZmIyZDU1ZTU1NDEwYmY5OTQ6U0lURV9ORVJJVDphUTdmODkyWnc`

        }

        if(Object.keys(params).length > 0 )
            reqUrl += (reqUrl.indexOf('?') === -1 ? '?' : '&') + queryParams(params)

        delete fetchParams.body
    }



    return fetch(reqUrl, fetchParams)
}


export const createGetRequest = (url, token, params, schema) => createRequest(METHOD_GET, url, token, params, schema)
export const createPostRequest = (url, token, params, schema ) => createRequest(METHOD_POST, url, token, params, schema)
export const createUpdateRequest = (url, token, params , schema) => createRequest(METHOD_PUT, url, token, params , schema)
export const createDeleteRequest = (url, token, params, schema) => createRequest(METHOD_DELETE, url, token, params, schema)



// WEBPACK FOOTER //
// ./src/helpers/create-request.js